/**
 *
 * @param featureSettings
 * @param currentTimePeriod
 * @returns {boolean}
 */
export function canDisplayFeature(featureSettings, currentTimePeriod) {
    return featureSettings.active === true && featureSettings.displayTimePeriods.indexOf(currentTimePeriod) > -1;
}